/* ==========================================================================
   Black November / Black Week 2026

   1) Nedtællinger: alle elementer med data-mc-cd tæller ned til 1/12 kl. 00.00
      (slutningen af Black Week), også i Black November.
      data-mcbn-navn får fasens navn.
   2) Pakke-knapper (data-mcbn-add="variant:antal,variant:antal") lægger flere
      varer i kurven på én gang. Kurv-drawer'en åbner af sig selv.
   3) Gave i Black Week: ligger der en fodmassager i kurven, lægges gaven i
      kurven automatisk (én pr. ordre). Rabatten, der gør den gratis, er en
      automatisk "Køb X, få Y" i Shopify. Fjernes fodmassageren, fjernes gaven.
      Fjerner kunden selv gaven, lægges den ikke i igen i samme besøg.
      Hvilken gave det er, vælges i Tilpas > Black November-bjælke.
   ========================================================================== */
(function () {
  'use strict';

  var BN = window.mcBN || { fase: 'efter' };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartPath = (window.routes && window.routes.cart_url) || root + 'cart';

  /* 1) nedtællinger -------------------------------------------------------- */
  /* Alle nedtællinger kører til 1/12 kl. 00.00 (BN.C), også i Black November (Jens 27/10) */
  function slut() {
    if (BN.fase === 'bn' || BN.fase === 'bw') return BN.C;
    return 0;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tael() {
    var end = slut();
    var t = Math.max(0, Math.floor((end - Date.now()) / 1000));
    var d = Math.floor(t / 86400); t -= d * 86400;
    var h = Math.floor(t / 3600); t -= h * 3600;
    var m = Math.floor(t / 60); var s = t - m * 60;
    var els = document.querySelectorAll('[data-mc-cd]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var q = function (k) { return el.querySelector('[data-' + k + ']'); };
      if (q('d')) q('d').textContent = pad(d);
      if (q('h')) q('h').textContent = pad(h);
      if (q('m')) q('m').textContent = pad(m);
      if (q('s')) q('s').textContent = pad(s);
    }
  }
  function navne() {
    var navn = BN.fase === 'bw' ? 'BLACK WEEK' : 'BLACK NOVEMBER';
    var els = document.querySelectorAll('[data-mcbn-navn]');
    for (var i = 0; i < els.length; i++) els[i].textContent = navn;
    /* Menupunktet: Black November, Black Week, og Black Friday på selve dagen (27/11 = 4 døgn før BN.C) */
    var nu = Date.now();
    var meny = BN.fase === 'bw' ? ((BN.C && nu >= BN.C - 4 * 864e5 && nu < BN.C - 3 * 864e5) ? 'Black Friday' : 'Black Week') : 'Black November';
    var mm = document.querySelectorAll('[data-mcbn-meny]');
    for (var j = 0; j < mm.length; j++) mm[j].textContent = meny;
  }

  /* 2) pakke-knapper ------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-mcbn-add]') : null;
    if (!b) return;
    e.preventDefault();
    var items = b.getAttribute('data-mcbn-add').split(',').map(function (p) {
      var x = p.split(':');
      return { id: parseInt(x[0], 10), quantity: parseInt(x[1] || '1', 10) };
    });
    b.classList.add('is-busy');
    /* tilføj kun det, der mangler: ligger varen allerede i kurven, lægges der ikke en ekstra i */
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; })
      .then(function (kurv) {
        var har = {};
        (kurv.items || []).forEach(function (i) { har[i.variant_id] = (har[i.variant_id] || 0) + i.quantity; });
        var mangler = items.map(function (i) { return { id: i.id, quantity: i.quantity - (har[i.id] || 0) }; })
          .filter(function (i) { return i.quantity > 0; });
        if (!mangler.length) { window.location.href = cartPath; return {}; }
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: mangler })
        }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
      })
      .catch(function () { window.location.href = b.getAttribute('href') || cartPath; })
      .then(function () { b.classList.remove('is-busy'); });
  });

  /* 3) gaven -------------------------------------------------------------- */
  var cfg = document.getElementById('mc-bn-gave');
  var fmIds = cfg ? (cfg.getAttribute('data-fm') || '').split(',').map(Number).filter(Boolean) : [];
  var gaveId = cfg ? Number(cfg.getAttribute('data-gave')) : 0;
  var gaveAktiv = cfg && cfg.getAttribute('data-aktiv') === 'true' && BN.fase === 'bw' && fmIds.length && gaveId;
  var KEY_LAGT = 'mc_bn_gave_lagt';
  var KEY_FJERNET = 'mc_bn_gave_fjernet';
  var travl = false;
  var orig = window.fetch;

  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }

  function opdaterKurv() {
    if (window.location.pathname === cartPath) { window.location.reload(); return; }
    var d = document.getElementById('cv2-drawer');
    if (d && typeof d.refresh === 'function') d.refresh();
  }

  function tjekGave() {
    if (!gaveAktiv || travl) return;
    travl = true;
    orig.call(window, root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fm = 0, gaveLinjer = [];
        cart.items.forEach(function (it) {
          if (fmIds.indexOf(it.variant_id) > -1) fm += it.quantity;
          if (it.variant_id === gaveId && it.properties && it.properties._mc_gave) gaveLinjer.push(it);
        });

        if (fm > 0 && gaveLinjer.length === 0) {
          if (ss(KEY_LAGT) === '1') { ss(KEY_FJERNET, '1'); return null; }
          if (ss(KEY_FJERNET) === '1') return null;
          ss(KEY_LAGT, '1');
          return orig.call(window, root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: gaveId, quantity: 1, properties: { _mc_gave: 'Black Week' } }] })
          }).then(function () { if (window.location.pathname === cartPath) window.location.reload(); });
        }

        if (fm === 0 && gaveLinjer.length) {
          ss(KEY_LAGT, '0');
          return orig.call(window, root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: gaveLinjer[0].key, quantity: 0 })
          }).then(opdaterKurv);
        }

        if (gaveLinjer.length && gaveLinjer[0].quantity > 1) {
          return orig.call(window, root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: gaveLinjer[0].key, quantity: 1 })
          }).then(opdaterKurv);
        }
        return null;
      })
      .catch(function () {})
      .then(function () { travl = false; });
  }

  if (gaveAktiv && orig) {
    var erKurv = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (erKurv.test(String(url))) p.then(function () { setTimeout(tjekGave, 250); });
      return p;
    };
    var xo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (erKurv.test(String(url))) this.addEventListener('load', function () { setTimeout(tjekGave, 250); });
      return xo.apply(this, arguments);
    };
  }

  /* 4) produktsiden (GemPages): tilbudsboks + Massage Gun-tilvalg ---------- */
  function pdp() {
    var tpl = document.getElementById('mc-bn-pdp');
    if (!tpl || (BN.fase !== 'bn' && BN.fase !== 'bw')) return;
    /* GemPages har en kasse til computer og en til mobil; boksen lægges ind i begge og arver deres synlighed */
    var maal = [].slice.call(document.querySelectorAll('.gEfTxt26a, .gEfTxt26m'));
    /* Efterårsboksen er fjernet fra GemPages-siden (uge 44): så lægges boksene lige før den første købsknap,
       der ikke sidder i den klæbende bjælke (gp-sticky). flytBog flytter e-bogen ned under knappen, og dubletter springes over. */
    if (!maal.length) {
      [].slice.call(document.querySelectorAll('gp-product-button')).filter(function (kn) { return !kn.closest('gp-sticky, [class*="sticky"]'); }).slice(0, 1).forEach(function (kn) {
        if (!kn.parentElement) return;
        var holder = document.createElement('div');
        holder.className = 'mcbp-holder';
        kn.parentElement.insertBefore(holder, kn);
        maal.push(holder);
      });
    }
    maal.forEach(function (el) {
      var boks = tpl.content.firstElementChild.cloneNode(true);
      el.appendChild(boks);
      flytBog(boks);
      /* I Black November er der ingen tilbudsboks (Jens 26/10): kun Black Week-boksen med gaven bliver stående */
      if (!boks.querySelector('[data-mc-vis~="' + BN.fase + '"]')) boks.remove();
    });
    if (!maal.length) {
      var k = document.querySelector('kaching-bundle');
      if (k) k.insertAdjacentElement('beforebegin', tpl.content.firstElementChild.cloneNode(true));
    }
    document.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('[data-mc-gun]')) return;
      var on = e.target.checked;
      [].forEach.call(document.querySelectorAll('[data-mc-gun]'), function (c) { c.checked = on; c.closest('.mcbp__add').classList.toggle('is-on', on); });
    });
  }
  /* E-bogsboksen står under købsknappen (efter leveringslinjen), ikke over den (Jens 26/10) */
  function flytBog(boks) {
    var bog = boks.querySelector('.mcbp__bog');
    if (!bog) return;
    var a = boks.parentElement, knap = null;
    while (a && a !== document.body) {
      knap = [].slice.call(a.querySelectorAll('gp-product-button')).filter(function (b) {
        return boks.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING;
      })[0];
      if (knap) break;
      a = a.parentElement;
    }
    if (!knap) return;
    var blok = knap;
    while (blok.parentElement && blok.parentElement !== a) blok = blok.parentElement;
    var efter = blok, t = blok.nextElementSibling;
    while (t && t.tagName === 'SCRIPT') t = t.nextElementSibling;
    if (t && t.innerText && t.innerText.length < 140 && !t.querySelector('button, input, select, gp-product-button')) efter = t;
    /* Computer- og mobilkassen kan pege på samme knap: kun én e-bogsboks pr. sted */
    var naeste = efter.nextElementSibling;
    if (naeste && naeste.classList.contains('mcbp--bog')) { bog.remove(); return; }
    var hylde = document.createElement('div');
    hylde.className = 'mcbp mcbp--bog';
    hylde.appendChild(bog);
    efter.insertAdjacentElement('afterend', hylde);
  }
  function gunValgt() {
    var c = document.querySelector('[data-mc-gun]');
    return c && c.checked ? Number(c.getAttribute('data-mc-gun')) : 0;
  }
  if (orig && document.getElementById('mc-bn-pdp')) {
    var forrige = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = forrige.apply(this, arguments);
      var gun = gunValgt();
      if (gun && /\/cart\/add(\.js)?(\?|$)/.test(String(url)) && !(init && init.__mcGun)) {
        p.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(function (j) {
            var items = j.items || [j];
            var harFm = items.some(function (it) { return fmIds.indexOf(it.variant_id) > -1; });
            var harGun = items.some(function (it) { return it.variant_id === gun; });
            if (!harFm || harGun) return;
            orig.call(window, root + 'cart/add.js', {
              method: 'POST', __mcGun: true,
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: gun, quantity: 1 }] })
            }).then(opdaterKurv);
          }).catch(function () {});
        });
      }
      return p;
    };
  }

  /* Gaven gives kun i Black Week. Ligger der en gave i kurven uden for Black Week
     (fx lagt i kurven 30/11 og betalt 1/12), fjernes den, så kunden ikke betaler for den. */
  function rydGave() {
    if (BN.fase === 'bw' || !orig) return;
    orig.call(window, root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var upd = {}, n = 0;
        cart.items.forEach(function (it) { if (it.properties && it.properties._mc_gave) { upd[it.key] = 0; n++; } });
        if (!n) return null;
        return orig.call(window, root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: upd })
        }).then(opdaterKurv);
      })
      .catch(function () {});
  }

  /* Forhåndsvisning før 1/11: siden /pages/black-week er skjult indtil 1/11, så links til den åbner
     tilbudssiden via ?view=black-week i stedet. På det publicerede tema (role main) røres intet. */
  function previewLinks() {
    var t = window.Shopify && window.Shopify.theme;
    if (!t || t.role === 'main') return;
    var as = document.querySelectorAll('a[href$="/pages/black-week"]');
    for (var i = 0; i < as.length; i++) as[i].setAttribute('href', root + 'pages/contact?view=black-week');
  }

  function init() {
    previewLinks();
    rydGave();
    pdp();
    navne();
    if (slut()) { tael(); setInterval(tael, 1000); }
    tjekGave();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
